import { useEffect, useRef, useState } from "react";

export function useDragging(_x: number, _y: number, parentSizeX: number, parentSizeY: number) {
    const [isDragging, setIsDragging] = useState(false);
    const [pos, setPos] = useState({ x: _x, y: _y });
    const ref = useRef<HTMLDivElement>(null);



    function onMouseMove(e: { target: any, pageX: number, pageY: number, x: number; y: number; stopPropagation: () => void; preventDefault: () => void; }) {
        if (!isDragging) return;
        if (ref.current)
            setPos({
                x: e.pageX - (parentSizeX / 2),
                y: e.pageY - (parentSizeY / 2),
            });
        e.stopPropagation();
        e.preventDefault();

    }


    function onMouseUp(e: { stopPropagation: () => void; preventDefault: () => void; }) {
        setIsDragging(false);
        e.stopPropagation();
        e.preventDefault();
    }

    function onMouseDown(e: { target: any, button: number; x: number; y: number; stopPropagation: () => void; preventDefault: () => void; }) {
        if (e.target.classList.contains("draggable") || e.target.parentElement.classList.contains("draggable")) {
            if (e.button !== 0) return;
            setIsDragging(true);
            e.stopPropagation();
            e.preventDefault();
        }
    }

    // When the element mounts, attach an mousedown listener
    useEffect(() => {
        if (ref.current)
            ref.current.addEventListener("mousedown", onMouseDown);

        return () => {
            if (ref.current)
                ref.current.removeEventListener("mousedown", onMouseDown);
        };
    }, [ref.current]);

    // Everytime the isDragging state changes, assign or remove
    // the corresponding mousemove and mouseup handlers
    useEffect(() => {
        if (isDragging) {
            document.addEventListener("mouseup", onMouseUp);
            document.addEventListener("mousemove", onMouseMove);
        } else {
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
        }
        return () => {
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
        };
    }, [isDragging]);

    return { ref, x: pos.x, y: pos.y, isDragging, setPos };
}